import { render, staticRenderFns } from "./myExam.vue?vue&type=template&id=cffa5d9e&scoped=true"
import script from "./myExam.vue?vue&type=script&lang=js"
export * from "./myExam.vue?vue&type=script&lang=js"
import style0 from "./myExam.vue?vue&type=style&index=0&id=cffa5d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffa5d9e",
  null
  
)

export default component.exports